import React from 'react';
class Clock extends React.Component {
	constructor(props){
		super(props);
		this.state ={
			time: new Date(new Date().toLocaleString("en-US", {timeZone: props.timezone})).toLocaleString()
		}
	}
	componentDidMount() {
	  this.intervalID = setInterval(() => this.updateClock(), 1000);
	}
	componentWillUnmount(){
		clearInterval(this.intervalID)
	}
	updateClock(){
		this.setState({ time: new Date(new Date().toLocaleString("en-US", {timeZone: this.props.timezone})).toLocaleString() });
	}
  render() {
    return (
      <div className="add-city bg-danger">
        <span id="clock">Please schedule offer according to {this.props.timezone} timezone The current time is {this.state.time}.</span>
        <br />
      </div>

    );
  }
}
export default Clock;


// WEBPACK FOOTER //
// ./src/app/views/admin/deal/Clock.js